import React, {useEffect, useState} from "react";
import Dropdown from "../Dropdown/Dropdown";
import {fetchRecordGroups} from "./recordGroupsService";
import "./RecordGroupFilterDropdown.scss";

export default function RecordGroupFilterDropdown(props) {
  var groupType = props.groupType;
  var ownerAgentId = props.ownerAgentId ? Number(props.ownerAgentId) : null;
  var value = props.value;
  var valueKey = props.valueKey || "group_id";
  var label = props.label || "Group";
  var theme = props.theme || "dark";
  var disabled = props.disabled;
  var isFilter = props.isFilter !== false;
  var data = props.data || {};
  var handleParentChange = props.handleParentChange;
  var className = props.className || "";
  var inline = props.inline === true;

  var groupsState = useState([]);
  var groups = groupsState[0];
  var setGroups = groupsState[1];

  var isLoadingState = useState(false);
  var isLoading = isLoadingState[0];
  var setIsLoading = isLoadingState[1];

  useEffect(function() {
    if (!ownerAgentId) {
      setGroups([]);
      return;
    }
    setIsLoading(true);
    fetchRecordGroups(groupType, ownerAgentId).then(function(nextGroups) {
      setGroups(nextGroups || []);
      setIsLoading(false);
    }).catch(function() {
      setGroups([]);
      setIsLoading(false);
    });
  }, [groupType, ownerAgentId]);

  var selectedValue = value === null || typeof value === "undefined" ? "" : String(value);
  var options = (groups || []).map(function(group) {
    return {
      group_id: String(group.group_id),
      group_name: group.group_name,
    };
  });

  function onNativeChange(event) {
    var nextValue = event.target.value;
    var updatedData = Object.assign({}, data);
    if (nextValue) {
      updatedData[valueKey] = nextValue;
    } else {
      delete updatedData[valueKey];
    }
    if (handleParentChange) {
      handleParentChange(updatedData, null, nextValue, valueKey);
    }
  }

  if (!inline) {
    return (
      <Dropdown
        theme={theme}
        options={options}
        optionsType="filters"
        optionKey="group_id"
        optionLabelKey="group_name"
        value={selectedValue || undefined}
        valueKey={valueKey}
        label={label}
        data={data}
        disabled={disabled || !ownerAgentId || isLoading}
        isFilter={isFilter}
        handleParentChange={handleParentChange}
        placeholder={isLoading ? "Loading groups..." : "All Groups"}
        className={className}
      />
    );
  }

  return (
    <div
      className={
        "RecordGroupFilterDropdown RecordGroupFilterDropdown--inline" +
        (className ? " " + className : "")
      }
      data-is-loading={isLoading ? true : null}
    >
      <label className="RecordGroupFilterDropdown_label">{label}</label>
      <select
        className="RecordGroupFilterDropdown_select"
        value={selectedValue}
        onChange={onNativeChange}
        disabled={disabled || !ownerAgentId || isLoading}
      >
        <option value="">
          {isLoading ? "Loading groups..." : "All Groups"}
        </option>
        {options.map(function(group) {
          return (
            <option key={group.group_id} value={group.group_id}>
              {group.group_name}
            </option>
          );
        })}
      </select>
    </div>
  );
}
